import { DatePipe } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { ExtendedProfileField } from '../../../../core/profiles/entities/extended-profile-field.entity';
import { ApiFragment } from '../../../../core/records/entities/api-fragment.class';
import { FieldReadHelper } from '../../../../profile-form/helpers/fields/field-read.helper';
import { Cell } from '../../components/cells/_base/table-cell.entity';
import { TextCell } from '../../components/cells/text-cell/text-cell.entity';
import { ColumnWidth } from '../../entities/column-width.entity';
import { ProfileFieldColumnService } from '../base-columns/profile-field-column.service';

@Injectable({ providedIn: 'root' })
export class DateFieldColumnService extends ProfileFieldColumnService<ApiFragment> {
    protected readonly WIDTH: ColumnWidth = ColumnWidth.WIDE;
    protected readonly DISABLE_SORT: boolean = false;
    private readonly fieldReadHelper: FieldReadHelper = inject(FieldReadHelper);
    private readonly datePipe: DatePipe = inject(DatePipe);

    getMapper(profileField: ExtendedProfileField): (item: ApiFragment) => Cell {
        return record => {
            const value: Date | null = this.fieldReadHelper.getDateFieldValue(profileField.FieldDefinition, record);
            const formattedDate: string = this.datePipe.transform(value, 'dd MMM yyyy, HH:mm') ?? '';
            return new TextCell(formattedDate);
        };
    }
}
